// extracted by mini-css-extract-plugin
module.exports = {"isActive":"collapsible_isActive__NNL_j","isInactive":"collapsible_isInactive__2UkZf","explaination":"collapsible_explaination__1_g-c"};